import {hot} from 'react-hot-loader/root';
import React from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import debounce from 'lodash/debounce';
import jwt_decode from 'jwt-decode';
import UuidEncoder from 'uuid-encoder';
// import {fetchRetry} from './utils/fetchRetry';
import {getSearchParams} from './utils/searchParams';
import AppProgress from './components/AppProgress';
import AppStepper from './components/AppStepper';
import AppError from './components/AppError';
import Step1 from './components/Steps/Step1';
import Step2 from './components/Steps/Step2';
import Step3 from './components/Steps/Step3';
import Step4 from './components/Steps/Step4';
import Invitation from './components/Routes/Invitation';
import Welcome from './components/Routes/Welcome';
import Finalize from './components/Routes/Finalize';

class App extends React.Component {
  constructor(props) {
    super(props);

    // API response handling
    this.handleResponse = this.handleResponse.bind(this);
    // global
    this.scrollToTop = this.scrollToTop.bind(this);
    this.scrollToStep = this.scrollToStep.bind(this);
    this.handleStep = this.handleStep.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.getCurrentStep = this.getCurrentStep.bind(this);
    this.getVerificationToken = this.getVerificationToken.bind(this);
    this.getResendToken = this.getResendToken.bind(this);
    this.getPlan = this.getPlan.bind(this);
    // step 1
    this.handleUserEmailChange = this.handleUserEmailChange.bind(this);
    this.handleSendLink = this.handleSendLink.bind(this);
    // step 2
    this.validateToken = this.validateToken.bind(this);
    this.validateRouteToken = this.validateRouteToken.bind(this);
    this.handleRoomNameChange = this.handleRoomNameChange.bind(this);
    this.validateRoomSystemName = debounce(
      this.validateRoomSystemName.bind(this),
      2000,
      {leading: false, trailing: true},
    );
    this.handleRoomCreate = this.handleRoomCreate.bind(this);
    // step 3
    this.handleStartProcessSetup = this.handleStartProcessSetup.bind(this);
    this.handleSkipProcessSetup = this.handleSkipProcessSetup.bind(this);
    this.handleGroupToggle = this.handleGroupToggle.bind(this);
    this.handleGroupInputChange = this.handleGroupInputChange.bind(this);
    this.handleGroupInputAdd = this.handleGroupInputAdd.bind(this);
    this.handlePersonChange = this.handlePersonChange.bind(this);
    this.handlePersonAdd = this.handlePersonAdd.bind(this);
    this.handlePersonRemove = this.handlePersonRemove.bind(this);
    this.handlePersonKeyDown = this.handlePersonKeyDown.bind(this);
    this.handleStrediskoAdd = this.handleStrediskoAdd.bind(this);
    this.handleStrediskoRename = this.handleStrediskoRename.bind(this);
    this.handleStrediskoRemove = this.handleStrediskoRemove.bind(this);
    this.handleProcessCheck = this.handleProcessCheck.bind(this);
    // step 4
    this.handlePostResources = this.handlePostResources.bind(this);
    // invitation + welcome
    this.handleUpdateUser = this.handleUpdateUser.bind(this);
    this.handleUpdateRoom = this.handleUpdateRoom.bind(this);
    this.handleResendInvitation = this.handleResendInvitation.bind(this);
    this.handleResendWelcome = this.handleResendWelcome.bind(this);
    this.handleRedirectToDm = this.handleRedirectToDm.bind(this);
    // end

    const currentStep = this.getCurrentStep();
    const verificationToken = this.getVerificationToken();
    const resendToken = this.getResendToken();
    const plan = this.getPlan();

    this.state = {
      // global
      currentStep: verificationToken ? currentStep : 1,
      displaySteps: undefined,
      verificationToken,
      resendToken,
      plan,
      dmApiToken: process.env.REACT_APP_DM_API_TOKEN,
      appError: undefined,
      // step 1
      userEmail: sessionStorage.getItem('dm-onboarding-user_email') || '',
      validUserEmail: false,
      linkSent: 'never',
      // step 2
      roomId: sessionStorage.getItem('dm-onboarding-room_id') || '',
      roomDisplayName:
        sessionStorage.getItem('dm-onboarding-room_display_name') || '',
      roomSystemName:
        sessionStorage.getItem('dm-onboarding-room_system_name') || '',
      validatingRoomSystemName: false,
      validRoomSystemName: false,
      // step 3
      startProcessSetup:
        sessionStorage.getItem('dm-onboarding-start_process_setup') || false,
      strediska: JSON.parse(
        sessionStorage.getItem('dm-onboarding-strediska'),
      ) || [
        {
          stredisko: '',
          recepcni: {chips: [], input: ''},
          predschvalovatel: {chips: [], input: ''},
          schvalovatel: {chips: [], input: ''},
          ucetni: {chips: [], input: ''},
          nahlizitel: {chips: [], input: ''},
        },
      ],
      strediskaGroupInputs: {
        recepcni: '',
        predschvalovatel: '',
        schvalovatel: '',
        ucetni: '',
        nahlizitel: '',
      },
      optionalRoles: JSON.parse(
        sessionStorage.getItem('dm-onboarding-optional_roles'),
      ) || {
        predschvalovatel: false,
        nahlizitel: false,
      },
      processWithErrors: false,
      postingResources: false,
    };

    this.apiURL = process.env.REACT_APP_DM_API_URL;
    this.dmURL = process.env.REACT_APP_DM_URL;
  }

  // API response handling

  handleResponse(
    response,
    message,
    shouldThrow,
    routeName,
    validatingRoomSystemName,
  ) {
    if (response.ok || (validatingRoomSystemName && response.status === 404)) {
      console.log(`${message} = success`, response.status, response.statusText);
    } else {
      console.error(`${message} = error`, response.status, response.statusText);

      response
        .json()
        .then(res => {
          switch (res.title) {
            case 'Given room ID is not allowed':
              this.setState({appError: 'roomAlreadyCreated'}, this.scrollToTop);
              break;
            case 'Token has expired':
              switch (routeName) {
                case 'invitation':
                  this.setState(
                    {appError: 'tokenExpiredInvitation'},
                    this.scrollToTop,
                  );
                  break;
                case 'welcome':
                  this.setState(
                    {appError: 'tokenExpiredWelcome'},
                    this.scrollToTop,
                  );
                  break;
                default:
                  this.setState({appError: 'tokenExpired'}, this.scrollToTop);
                  break;
              }
              break;
            case 'Token is invalid':
              switch (routeName) {
                case 'invitation':
                  this.setState(
                    {appError: 'tokenRouteInvalid'},
                    this.scrollToTop,
                  );
                  break;
                case 'welcome':
                  this.setState(
                    {appError: 'tokenRouteInvalid'},
                    this.scrollToTop,
                  );
                  break;
                default:
                  this.setState({appError: 'tokenInvalid'}, this.scrollToTop);
                  break;
              }
              break;
            default:
              this.setState({appError: 'default'}, this.scrollToTop);
              break;
          }
        })
        .catch(error => {
          console.error(error);
          this.setState({appError: 'default'}, this.scrollToTop);
        });

      if (shouldThrow) {
        throw new Error('There was an error...');
      }
    }

    return response.ok;
  }

  // global

  scrollToTop() {
    window.scroll(0, 0);
  }

  scrollToStep(step) {
    const {displaySteps} = this.state;
    if (document.getElementById(`step${step}`)) {
      if (displaySteps === '43') {
        window.scroll({behavior: 'smooth', left: 0, top: 0});
      } else {
        const prevStep = document.getElementById(
          `step${displaySteps.charAt(displaySteps.length - 2)}`,
        );

        window.scroll({
          behavior: 'smooth',
          left: 0,
          top: prevStep.clientHeight,
        });
      }
    }
    setTimeout(() => {
      this.setState({displaySteps: undefined}, () => {
        this.scrollToTop();
        document.body.classList.remove('appScrollingBody');
      });
    }, 500);
  }

  handleStep(step) {
    const scrollY = window.scrollY;
    this.setState({displaySteps: `${this.state.currentStep}${step}`}, () => {
      document.activeElement.blur();
      document.body.classList.add('appScrollingBody');
      this.setState({currentStep: step}, () => {
        if (document.getElementById(`step${step}`)) {
          if (this.state.displaySteps === '43') {
            window.scroll(
              0,
              scrollY + document.getElementById(`step${step}`).clientHeight,
            );
          } else {
            window.scroll(0, scrollY);
          }
        }
        this.scrollToStep(step);
        sessionStorage.setItem(
          'dm-onboarding-current_step',
          this.state.currentStep,
        );
      });
    });
  }

  validateEmail(email) {
    return Boolean(
      email.match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      ),
    );
  }

  getCurrentStep() {
    const currentStep = sessionStorage.getItem('dm-onboarding-current_step');
    // TODO: is session lost on history change?
    return currentStep ? Number(currentStep) : 2;
  }

  getVerificationToken() {
    const params = getSearchParams();
    const {token} = params;
    if (!token) {
      console.log('.. NO VERIFICATION TOKEN FOUND IN PARAMS ..');
      sessionStorage.removeItem('dm-onboarding-current_step');
      sessionStorage.removeItem('dm-onboarding-user_email');
      sessionStorage.removeItem('dm-onboarding-room_id');
      sessionStorage.removeItem('dm-onboarding-room_display_name');
      sessionStorage.removeItem('dm-onboarding-room_system_name');
      sessionStorage.removeItem('dm-onboarding-start_process_setup');
      sessionStorage.removeItem('dm-onboarding-strediska');
      sessionStorage.removeItem('dm-onboarding-optional_roles');

      window.Intercom('boot', {
        app_id: process.env.REACT_APP_INTERCOM_APP_ID,
      });
      console.log('>> INITIALIZING INTERCOM >>');

      return undefined;
    } else {
      console.log(`>> GETTING VERIFICATION TOKEN FROM PARAMS: ${token} >>`);

      try {
        const decodedToken = jwt_decode(token);
        const userEmail = decodedToken.sub.split(' ')[1];
        if (this.validateEmail(userEmail)) {
          window.Intercom('boot', {
            app_id: process.env.REACT_APP_INTERCOM_APP_ID,
            anonymous_email: userEmail,
          });
          console.log(`>> SETTING INTERCOM USER EMAIL: ${userEmail} >>`);
        } else {
          console.log('.. CANNOT SET INTERCOM USER EMAIL ..');
        }
      } catch (error) {
        console.log('.. CANNOT SET INTERCOM USER EMAIL ..');
      }

      return token;
    }
  }

  getResendToken() {
    const params = getSearchParams();
    const {resend_token} = params;
    if (!resend_token) {
      console.log('.. NO RESEND TOKEN FOUND IN PARAMS ..');
      return undefined;
    } else {
      console.log(`>> GETTING RESEND TOKEN FROM PARAMS: ${resend_token} >>`);
      return resend_token;
    }
  }

  getPlan() {
    const params = getSearchParams();
    const {plan} = params;
    if (
      plan === 'start' ||
      plan === 'team-monthly' ||
      plan === 'team-yearly' ||
      plan === 'business-monthly' ||
      plan === 'business-yearly'
    ) {
      console.log(`>> GETTING PLAN FROM PARAMS: ${plan} >>`);
      return plan;
    } else {
      console.log('.. NO PLAN FOUND IN PARAMS ..');
      return undefined;
    }
  }

  // step 1

  handleUserEmailChange(e) {
    this.setState({userEmail: e.target.value, validUserEmail: false}, () => {
      const validUserEmail = this.validateEmail(this.state.userEmail);
      this.setState({validUserEmail});
    });
  }

  handleSendLink() {
    const {dmApiToken, linkSent, validUserEmail, verificationToken, plan} =
      this.state;
    let userEmail = this.state.userEmail;
    let emailSetFromToken = false;

    if (userEmail.length === 0) {
      let decodedToken;
      try {
        decodedToken = jwt_decode(verificationToken);
      } catch (error) {
        console.error('.. SOMETHING WENT WRONG ..', error);
        this.setState({appError: 'tokenInvalid'}, this.scrollToTop);
        return;
      }
      userEmail = decodedToken.sub.split(' ')[1];
      emailSetFromToken = true;
    }

    if (validUserEmail || emailSetFromToken) {
      this.setState({linkSent: linkSent === 'once' ? 'twice' : 'once'}, () => {
        console.log(`>> SENDING LINK TO: ${userEmail} >>`);
        fetch(`${this.apiURL}/rooms:verify-email-for-onboarding`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${dmApiToken}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            data: {
              email: userEmail,
              urlParameters: plan ? [['plan', plan]] : undefined,
            },
          }),
        }).then(response =>
          this.handleResponse(
            response,
            'POST /rooms:verify-email-for-onboarding',
          ),
        );

        if (this.state.linkSent === 'once') {
          window.Intercom('boot', {
            app_id: process.env.REACT_APP_INTERCOM_APP_ID,
            anonymous_email: userEmail,
          });
          console.log(`>> SETTING INTERCOM USER EMAIL: ${userEmail} >>`);
          window.Intercom('trackEvent', 'started-onboarding');
          if (window.dataLayer) {
            window.dataLayer.push({event: 'started-onboarding'});
          }
        }
      });
    } else {
      console.log('.. INVALID USER EMAIL ..');
    }
  }

  // step 2

  async validateToken() {
    const {verificationToken} = this.state;

    console.log('>> VALIDATE TOKEN >>');

    await fetch(
      `${this.apiURL}/rooms/${
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15)
      }:verify-availability`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${verificationToken}`,
          'Content-Type': 'application/json',
        },
      },
    ).then(response => this.handleResponse(response, 'VALIDATE TOKEN'));
  }

  async validateRouteToken(routeName) {
    const {verificationToken} = this.state;
    let decodedToken;
    try {
      decodedToken = jwt_decode(verificationToken);
    } catch (error) {
      console.error('.. SOMETHING WENT WRONG ..', error);
      this.setState({appError: 'tokenRouteInvalid'}, this.scrollToTop);
      return;
    }
    const userEmail = decodedToken.sub.split(' ')[1];

    console.log('>> VALIDATE ROUTE TOKEN >>');

    await fetch(`${this.apiURL}/users/${userEmail}`, {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${verificationToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        data: {},
      }),
    }).then(response =>
      this.handleResponse(
        response,
        'VALIDATE ROUTE TOKEN',
        undefined,
        routeName,
      ),
    );
  }

  handleRoomNameChange(e, type) {
    const displayName = e.target.value;
    const matchedSystemName = displayName
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[_-\s]/g, '-')
      .match(/[a-zA-Z0-9-]/g);
    const systemName = matchedSystemName
      ? matchedSystemName.join('').replace(/-+/g, '-')
      : '';

    this.setState(
      {
        roomDisplayName:
          type === 'system' ? this.state.roomDisplayName : displayName,
        roomSystemName: systemName,
        validRoomSystemName: false,
        validatingRoomSystemName: true,
      },
      this.validateRoomSystemName,
    );
  }

  validateRoomSystemName() {
    this.setState(
      {
        roomDisplayName: this.state.roomDisplayName.trim().replace(/\s+/g, ' '),
        roomSystemName: this.state.roomSystemName.replace(/^-+|-+$/g, ''),
      },
      async () => {
        const {verificationToken, roomSystemName} = this.state;
        if (roomSystemName.length > 0) {
          console.log('>> VALIDATE ROOM SYSTEM NAME AGAINST API >>');

          const validRoomSystemName = await fetch(
            `${this.apiURL}/rooms/${roomSystemName}:verify-availability`,
            {
              method: 'POST',
              headers: {
                Authorization: `Bearer ${verificationToken}`,
                'Content-Type': 'application/json',
              },
            },
          ).then(response =>
            this.handleResponse(
              response,
              `POST /rooms/${roomSystemName}:verify-availability`,
              undefined,
              undefined,
              true,
            ),
          );

          this.setState(
            {
              validRoomSystemName,
              validatingRoomSystemName: false,
            },
            () =>
              console.log(
                `.. ${
                  validRoomSystemName ? '' : 'IN'
                }VALID ROOM SYSTEM NAME ..`,
              ),
          );
        } else {
          this.setState({
            validRoomSystemName: false,
            validatingRoomSystemName: false,
          });
        }
      },
    );
  }

  handleRoomCreate() {
    const {
      roomDisplayName,
      roomSystemName,
      validRoomSystemName,
      verificationToken,
      plan,
    } = this.state;

    let planId;
    switch (plan) {
      case 'team-monthly':
        planId = process.env.REACT_APP_SUBSCRIPTION_TEAM_MONTHLY;
        break;
      case 'team-yearly':
        planId = process.env.REACT_APP_SUBSCRIPTION_TEAM_YEARLY;
        break;
      case 'business-monthly':
        planId = process.env.REACT_APP_SUBSCRIPTION_BUSINESS_MONTHLY;
        break;
      case 'business-yearly':
        planId = process.env.REACT_APP_SUBSCRIPTION_BUSINESS_YEARLY;
        break;
      default:
        break;
    }

    if (roomDisplayName && validRoomSystemName) {
      console.log('>> CREATING ROOM >>');
      fetch(`${this.apiURL}/rooms`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${verificationToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            name: roomDisplayName,
            systemName: roomSystemName,
            subscriptions: planId
              ? [
                  {
                    data: {
                      planVariant: {
                        data: {
                          id: planId,
                          type: 'plan-variant',
                        },
                      },
                    },
                  },
                ]
              : undefined,
          },
        }),
      }).then(response => {
        const ok = this.handleResponse(response, 'POST /rooms');
        if (ok) {
          response.json().then(data => {
            let decodedToken;
            try {
              decodedToken = jwt_decode(this.state.verificationToken);
            } catch (error) {
              console.error('.. SOMETHING WENT WRONG ..', error);
              this.setState({appError: 'tokenInvalid'}, this.scrollToTop);
              return;
            }
            const userEmail = decodedToken.sub.split(' ')[1];
            if (userEmail && data.data && data.data.id) {
              this.setState({userEmail, roomId: data.data.id}, () => {
                sessionStorage.setItem(
                  'dm-onboarding-user_email',
                  this.state.userEmail,
                );
                sessionStorage.setItem(
                  'dm-onboarding-room_id',
                  this.state.roomId,
                );
                sessionStorage.setItem(
                  'dm-onboarding-room_display_name',
                  this.state.roomDisplayName,
                );
                sessionStorage.setItem(
                  'dm-onboarding-room_system_name',
                  this.state.roomSystemName,
                );
                window.Intercom(
                  'trackEvent',
                  'completed-2nd-step-on-onboarding',
                );
                if (window.dataLayer) {
                  window.dataLayer.push({
                    event: 'completed-2nd-step-on-onboarding',
                  });
                }
                this.state.roomId &&
                  roomDisplayName &&
                  validRoomSystemName &&
                  this.handleStep(3);
              });
            } else {
              console.error('.. SOMETHING WENT WRONG ..');
              this.setState({appError: 'default'}, this.scrollToTop);
            }
          });
        }
      });
    } else {
      console.log('.. INVALID ROOM SYSTEM NAME ..');
    }
  }

  // step 3

  handleStartProcessSetup() {
    this.setState({startProcessSetup: true}, () => {
      sessionStorage.setItem(
        'dm-onboarding-start_process_setup',
        this.state.startProcessSetup,
      );

      console.log('>> START PROCESS SETUP >>');
      window.Intercom('trackEvent', 'started-3rd-step-on-onboarding');
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'started-3rd-step-on-onboarding',
        });
      }
    });
  }

  handleSkipProcessSetup() {
    console.log('>> SKIP PROCESS SETUP >>');
    window.Intercom('trackEvent', 'skipped-3rd-step-on-onboarding');
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'skipped-3rd-step-on-onboarding',
      });
    }

    this.handlePostResources();
  }

  handleGroupToggle(role) {
    const optionalRoles = {...this.state.optionalRoles};
    optionalRoles[role] = !optionalRoles[role];
    this.setState({processWithErrors: false, optionalRoles}, () => {
      sessionStorage.setItem(
        'dm-onboarding-optional_roles',
        JSON.stringify(this.state.optionalRoles),
      );
    });
  }

  handleGroupInputChange(role, value) {
    const {strediskaGroupInputs} = this.state;
    strediskaGroupInputs[role] = value;
    this.setState({processWithErrors: false, strediskaGroupInputs});
  }

  handleGroupInputAdd(role) {
    const {strediska, strediskaGroupInputs} = this.state;
    const isEmailValid = this.validateEmail(strediskaGroupInputs[role]);
    if (!isEmailValid) {
      return;
    }
    const newStrediska = strediska.map(stredisko => {
      if (
        !stredisko[role].chips.some(chip => chip === strediskaGroupInputs[role])
      ) {
        stredisko[role].chips = [
          ...stredisko[role].chips,
          strediskaGroupInputs[role],
        ];
      }
      return stredisko;
    });
    strediskaGroupInputs[role] = '';
    this.setState(
      {
        processWithErrors: false,
        strediska: newStrediska,
        strediskaGroupInputs,
      },
      () => {
        sessionStorage.setItem(
          'dm-onboarding-strediska',
          JSON.stringify(this.state.strediska),
        );
      },
    );
  }

  handlePersonChange(idx, role, value) {
    const strediska = this.state.strediska.map((stredisko, i) => {
      if (idx !== i) {
        return stredisko;
      }
      stredisko[role].input = value;
      return stredisko;
    });

    this.setState({processWithErrors: false, strediska}, () => {
      sessionStorage.setItem(
        'dm-onboarding-strediska',
        JSON.stringify(this.state.strediska),
      );
    });
  }

  handlePersonAdd(idx, role, email) {
    const isEmailValid = this.validateEmail(email);
    if (!isEmailValid) {
      return;
    }

    const strediska = this.state.strediska.map((stredisko, i) => {
      if (idx !== i) {
        return stredisko;
      }
      if (!stredisko[role].chips.some(chip => chip === email)) {
        stredisko[role].chips = [...stredisko[role].chips, email];
      }
      stredisko[role].input = '';
      return stredisko;
    });

    this.setState({processWithErrors: false, strediska}, () => {
      sessionStorage.setItem(
        'dm-onboarding-strediska',
        JSON.stringify(this.state.strediska),
      );
    });
  }

  handlePersonRemove(idx, role, chipIdx) {
    const strediska = this.state.strediska.map((stredisko, i) => {
      if (idx !== i) {
        return stredisko;
      }
      stredisko[role].chips = [
        ...stredisko[role].chips.slice(0, chipIdx),
        ...stredisko[role].chips.slice(chipIdx + 1),
      ];
      return stredisko;
    });

    this.setState({processWithErrors: false, strediska}, () => {
      sessionStorage.setItem(
        'dm-onboarding-strediska',
        JSON.stringify(this.state.strediska),
      );
    });
  }

  handlePersonKeyDown(e, idx, role, email) {
    if (e.key === ',' || e.key === ' ') {
      e.preventDefault();
      this.handlePersonAdd(idx, role, email);
    }
  }

  handleStrediskoAdd(count) {
    const strediska = [...this.state.strediska];

    for (let i = 0; i < count; i++) {
      strediska.push({
        stredisko: '',
        recepcni: {chips: [], input: ''},
        predschvalovatel: {chips: [], input: ''},
        schvalovatel: {chips: [], input: ''},
        ucetni: {chips: [], input: ''},
        nahlizitel: {chips: [], input: ''},
      });
    }

    this.setState({processWithErrors: false, strediska}, () => {
      sessionStorage.setItem(
        'dm-onboarding-strediska',
        JSON.stringify(this.state.strediska),
      );
    });
  }

  handleStrediskoRename(idx, value) {
    const strediska = JSON.parse(JSON.stringify(this.state.strediska));
    strediska[idx].stredisko = value;
    this.setState({processWithErrors: false, strediska}, () => {
      sessionStorage.setItem(
        'dm-onboarding-strediska',
        JSON.stringify(this.state.strediska),
      );
    });
  }

  handleStrediskoRemove(idx) {
    const strediska = [
      ...this.state.strediska.slice(0, idx),
      ...this.state.strediska.slice(idx + 1),
    ];
    this.setState({processWithErrors: false, strediska}, () => {
      sessionStorage.setItem(
        'dm-onboarding-strediska',
        JSON.stringify(this.state.strediska),
      );
    });
  }

  handleProcessCheck(processStarted, proceed, reset) {
    if (reset) {
      this.setState({processWithErrors: false});
      return;
    }
    if (!processStarted && proceed) {
      console.log('>> SKIPPING STEP 3 >>');
      window.Intercom('trackEvent', 'skipped-3rd-step-on-onboarding');
      if (window.dataLayer) {
        window.dataLayer.push({event: 'skipped-3rd-step-on-onboarding'});
      }
      this.handleStep(4);
    } else {
      const {strediska} = this.state;
      console.log('>> CHECKING PROCESS >>');

      strediska.forEach((stredisko, idx) => {
        this.handlePersonAdd(idx, 'recepcni', stredisko.recepcni.input);
        this.handlePersonAdd(
          idx,
          'predschvalovatel',
          stredisko.predschvalovatel.input,
        );
        this.handlePersonAdd(idx, 'schvalovatel', stredisko.schvalovatel.input);
        this.handlePersonAdd(idx, 'ucetni', stredisko.ucetni.input);
        this.handlePersonAdd(idx, 'nahlizitel', stredisko.nahlizitel.input);
      });

      const processWithErrors = strediska.some(
        (stredisko, index) =>
          (strediska.length > 1 &&
            (stredisko.stredisko.length === 0 ||
              strediska.some((item, idx) => {
                if (idx === index) {
                  return false;
                }
                return item.stredisko === stredisko.stredisko;
              }) ||
              stredisko.stredisko.length > 24)) ||
          (stredisko.recepcni.input.length > 0 &&
            !this.validateEmail(stredisko.recepcni.input)) ||
          (stredisko.predschvalovatel.input.length > 0 &&
            !this.validateEmail(stredisko.predschvalovatel.input)) ||
          (stredisko.schvalovatel.input.length > 0 &&
            !this.validateEmail(stredisko.schvalovatel.input)) ||
          (stredisko.ucetni.input.length > 0 &&
            !this.validateEmail(stredisko.ucetni.input)) ||
          (stredisko.nahlizitel.input.length > 0 &&
            !this.validateEmail(stredisko.nahlizitel.input)),
      );

      this.setState({processWithErrors}, () => {
        console.log(
          processWithErrors
            ? '.. PROCESS HAS ERRORS ..'
            : '.. PROCESS IS OK ..',
        );
        if (!processWithErrors && proceed) {
          window.Intercom('trackEvent', 'completed-3rd-step-on-onboarding');
          if (window.dataLayer) {
            window.dataLayer.push({event: 'completed-3rd-step-on-onboarding'});
          }
          this.handleStep(4);
        }
      });
    }
  }

  // step 4

  handlePostResources() {
    const {verificationToken, userEmail, strediska, optionalRoles} = this.state;

    const getUser = async email => {
      return await fetch(`${this.apiURL}/users/${email}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${verificationToken}`,
          'Content-Type': 'application/json',
        },
      }).then(async response => {
        const ok = this.handleResponse(response, `GET /users/${email}`, true);
        if (ok) {
          return response.json().then(data => data.data.id);
        }
      });
    };

    const postUser = async email => {
      return await fetch(`${this.apiURL}/users`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${verificationToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            email,
          },
        }),
      }).then(async response => {
        const ok = this.handleResponse(response, 'POST /users', true);
        if (ok) {
          return response.json().then(data => data.data.id);
        }
      });
    };

    const userRefs = [];
    const postAllUsers = async () => {
      const allEmails = [userEmail];
      let dedupedEmails = [];
      strediska.map(stredisko => {
        stredisko.recepcni.chips.map(email => allEmails.push(email));
        if (optionalRoles.predschvalovatel) {
          stredisko.predschvalovatel.chips.map(email => allEmails.push(email));
        }
        stredisko.schvalovatel.chips.map(email => allEmails.push(email));
        stredisko.ucetni.chips.map(email => allEmails.push(email));
        if (optionalRoles.nahlizitel) {
          stredisko.nahlizitel.chips.map(email => allEmails.push(email));
        }
        return allEmails;
      });

      dedupedEmails = [...new Set(allEmails)];

      for (const email of dedupedEmails) {
        const id =
          email === userEmail
            ? await getUser(userEmail)
            : await postUser(email);

        userRefs.push({email, id});
      }
    };

    const welcomeUser = async email => {
      return await fetch(`${this.apiURL}/users/${email}:welcome`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${verificationToken}`,
          'Content-Type': 'application/json',
        },
      }).then(response =>
        this.handleResponse(response, `POST /${email}:welcome`, true),
      );
    };

    const inviteUser = async email => {
      return await fetch(`${this.apiURL}/users/${email}:invite`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${verificationToken}`,
          'Content-Type': 'application/json',
        },
      }).then(response =>
        this.handleResponse(response, `POST /${email}:invite`, true),
      );
    };

    const sendEmailsToUsers = async () => {
      for (const user of userRefs) {
        user.email === userEmail
          ? await welcomeUser(userEmail)
          : await inviteUser(user.email);
      }
    };

    const postTeam = async (name, userIds) => {
      return await fetch(`${this.apiURL}/teams`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${verificationToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            name,
            users: {
              data: userIds.map(id => {
                return {
                  data: {
                    id,
                    type: 'user',
                  },
                };
              }),
            },
          },
        }),
      }).then(async response => {
        const ok = this.handleResponse(response, 'POST /teams', true);
        if (ok) {
          return response.json().then(data => data.data.id);
        }
      });
    };

    const teamRefs = [];
    const createTeams = () => {
      strediska.map(stredisko => {
        const strediskoTeams = [];

        const strediskoRecepcniIds = [];
        stredisko.recepcni.chips.map(email => {
          const user = userRefs.find(i => i.email === email);
          const userId = user.id;
          return strediskoRecepcniIds.push(userId);
        });
        strediskoTeams.push({
          name: `${
            strediska.length > 1 ? `${stredisko.stredisko} - ` : ''
          }Recepční`,
          userIds: strediskoRecepcniIds,
        });

        if (optionalRoles.predschvalovatel) {
          const strediskoPredschvalovatelIds = [];
          stredisko.predschvalovatel.chips.map(email => {
            const user = userRefs.find(i => i.email === email);
            const userId = user.id;
            return strediskoPredschvalovatelIds.push(userId);
          });
          strediskoTeams.push({
            name: `${
              strediska.length > 1 ? `${stredisko.stredisko} - ` : ''
            }Předschvalovatelé`,
            userIds: strediskoPredschvalovatelIds,
          });
        } else {
          strediskoTeams.push(undefined);
        }

        const strediskoSchvalovatelIds = [];
        stredisko.schvalovatel.chips.map(email => {
          const user = userRefs.find(i => i.email === email);
          const userId = user.id;
          return strediskoSchvalovatelIds.push(userId);
        });
        strediskoTeams.push({
          name: `${
            strediska.length > 1 ? `${stredisko.stredisko} - ` : ''
          }Schvalovatelé`,
          userIds: strediskoSchvalovatelIds,
        });

        const strediskoUcetniIds = [];
        stredisko.ucetni.chips.map(email => {
          const user = userRefs.find(i => i.email === email);
          const userId = user.id;
          return strediskoUcetniIds.push(userId);
        });
        strediskoTeams.push({
          name: `${
            strediska.length > 1 ? `${stredisko.stredisko} - ` : ''
          }Účetní`,
          userIds: strediskoUcetniIds,
        });

        const strediskoNahlizitelIds = [];
        stredisko.nahlizitel.chips.map(email => {
          const user = userRefs.find(i => i.email === email);
          const userId = user.id;
          return strediskoNahlizitelIds.push(userId);
        });
        strediskoTeams.push({
          name: `${
            strediska.length > 1 ? `${stredisko.stredisko} - ` : ''
          }Nahližitelé`,
          userIds: strediskoNahlizitelIds,
        });

        return teamRefs.push(strediskoTeams);
      });
    };

    const postAllTeams = async () => {
      createTeams();
      for (const strediskoTeams of teamRefs) {
        for (const team of strediskoTeams) {
          if (team) {
            const id = await postTeam(team.name, team.userIds);
            team.id = id;
          }
        }
      }
    };

    const postCabinet = async label => {
      return await fetch(`${this.apiURL}/cabinets`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${verificationToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            label,
          },
        }),
      }).then(async response => {
        const ok = this.handleResponse(response, 'POST /cabinets', true);
        if (ok) {
          return response.json().then(data => data.data.id);
        }
      });
    };

    const postShelf = async (id, label) => {
      return await fetch(`${this.apiURL}/shelves`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${verificationToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            cabinet: {
              data: {
                id,
                type: 'cabinet',
              },
            },
            label,
          },
        }),
      }).then(async response => {
        const ok = this.handleResponse(response, 'POST /shelves', true);
        if (ok) {
          return response.json().then(data => data.data.id);
        }
      });
    };

    const postTray = async id => {
      return await fetch(`${this.apiURL}/trays`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${verificationToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            shelf: {
              data: {
                id,
                type: 'shelf',
              },
            },
          },
        }),
      }).then(async response => {
        const ok = this.handleResponse(response, 'POST /trays', true);
        if (ok) {
          return response.json().then(data => data.data.id);
        }
      });
    };

    const postBinder = async (id, label, color) => {
      return await fetch(`${this.apiURL}/binders`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${verificationToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            label,
            color,
            shelf: {
              data: {
                id,
                type: 'shelf',
              },
            },
          },
        }),
      }).then(async response => {
        const ok = this.handleResponse(response, 'POST /binders', true);
        if (ok) {
          return response.json().then(data => data.data.id);
        }
      });
    };

    const PERMISSIONS = {
      ADMIN: [
        'add-document',
        'read-document',
        'share-document',
        'move-document',
        'modify-document',
        'trash-document',
        'shred-document',
      ],
      NORMAL_USER: [
        'add-document',
        'read-document',
        'share-document',
        'move-document',
        'modify-document',
        'trash-document',
      ],
      READ_CONTRIBUTE: ['add-document', 'read-document', 'share-document'],
      READ_MOVE: ['read-document', 'share-document', 'move-document'],
      CONTRIBUTOR: ['add-document'],
      READER_WITHOUT_SHARE: ['read-document'],
    };

    const postPermission = async (
      actions,
      effect,
      principalId,
      principalType,
      resourceId,
      resourceType,
    ) => {
      return await fetch(`${this.apiURL}/permissions`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${verificationToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            actions,
            effect,
            principal: {
              data: {
                id: principalId,
                type: principalType,
              },
            },
            resource: {
              data: {
                id: resourceId,
                type: resourceType,
              },
            },
          },
        }),
      }).then(response =>
        this.handleResponse(response, 'POST /permissions', true),
      );
    };

    const postShortcut = async (
      locationId,
      locationType,
      targetId,
      targetType,
      text,
      color,
    ) => {
      return await fetch(`${this.apiURL}/shortcuts`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${verificationToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            location: {
              data: {
                id: locationId,
                type: locationType,
              },
            },
            elements: [
              {
                type: 'button',
                text,
                color,
                action: {
                  type: 'move-document',
                  target: {
                    data: {
                      id: targetId,
                      type: targetType,
                    },
                  },
                },
              },
            ],
          },
        }),
      }).then(response =>
        this.handleResponse(response, 'POST /shortcuts', true),
      );
    };

    const setRoomDefaultEmailTarget = async trayId => {
      const {verificationToken} = this.state;
      let decodedToken;
      try {
        decodedToken = jwt_decode(verificationToken);
      } catch (error) {
        console.error('.. SOMETHING WENT WRONG ..', error);
        this.setState({appError: 'tokenInvalid'}, this.scrollToTop);
        return;
      }
      const encodedRoomUuid = decodedToken.sub.split(' ')[0];
      const encoder = new UuidEncoder('base58');
      const roomUuid = encoder.decode(encodedRoomUuid);

      return await fetch(`${this.apiURL}/rooms/${roomUuid}`, {
        method: 'PATCH',
        headers: {
          Authorization: `Bearer ${verificationToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            defaultEmailTarget: trayId,
          },
        }),
      }).then(response =>
        this.handleResponse(response, `PATCH /rooms/${roomUuid}`, true),
      );
    };

    const postResources = async () => {
      try {
        // users
        await postAllUsers();
        console.log(userRefs);

        // teams
        const adminTeamId = await postTeam('Správce firmy', [userRefs[0].id]);
        await postAllTeams();
        console.log(adminTeamId, teamRefs);

        // cabinet + admin permission
        const cabinetId = await postCabinet('Schvalování dokladů');
        await postPermission(
          PERMISSIONS.ADMIN,
          'allow',
          adminTeamId,
          'team',
          cabinetId,
          'cabinet',
        );

        // shelves
        const shelfPrijemId = await postShelf(cabinetId, 'Příjem');

        let shelfKeSchvaleni1Id = undefined;
        if (optionalRoles.predschvalovatel) {
          shelfKeSchvaleni1Id = await postShelf(
            cabinetId,
            'Ke schválení 1. úr.',
          );
        }

        const shelfKeSchvaleni2Id = await postShelf(
          cabinetId,
          optionalRoles.predschvalovatel
            ? 'Ke schválení 2. úr.'
            : 'Ke schválení',
        );

        const shelfSchvaleneDokladyId = await postShelf(
          cabinetId,
          'Schválené doklady',
        );

        const shelfArchivDokladuId = await postShelf(
          cabinetId,
          'Archiv dokladů',
        );

        // trays & binders + user permissions

        const shelfPrijemTrayId = await postTray(shelfPrijemId);

        for (const [idx, stredisko] of strediska.entries()) {
          // prijem
          await postPermission(
            PERMISSIONS.NORMAL_USER,
            'allow',
            teamRefs[idx][0].id,
            'team',
            shelfPrijemTrayId,
            'tray',
          );
          if (optionalRoles.predschvalovatel) {
            await postPermission(
              PERMISSIONS.NORMAL_USER,
              'allow',
              teamRefs[idx][1].id,
              'team',
              shelfPrijemTrayId,
              'tray',
            );
          }
          await postPermission(
            PERMISSIONS.NORMAL_USER,
            'allow',
            teamRefs[idx][2].id,
            'team',
            shelfPrijemTrayId,
            'tray',
          );
          await postPermission(
            PERMISSIONS.READER_WITHOUT_SHARE,
            'allow',
            teamRefs[idx][4].id,
            'team',
            shelfPrijemTrayId,
            'tray',
          );

          // ke schvaleni 1. ur.
          let shelfKeSchvaleni1BinderId = undefined;
          if (shelfKeSchvaleni1Id) {
            shelfKeSchvaleni1BinderId = await postBinder(
              shelfKeSchvaleni1Id,
              `${
                strediska.length > 1 ? `${stredisko.stredisko} - ` : ''
              }Ke schválení 1. úr.`,
              'yellow',
            );
            await postPermission(
              PERMISSIONS.CONTRIBUTOR,
              'allow',
              teamRefs[idx][0].id,
              'team',
              shelfKeSchvaleni1BinderId,
              'binder',
            );
            await postPermission(
              PERMISSIONS.NORMAL_USER,
              'allow',
              teamRefs[idx][1].id,
              'team',
              shelfKeSchvaleni1BinderId,
              'binder',
            );
            await postPermission(
              PERMISSIONS.NORMAL_USER,
              'allow',
              teamRefs[idx][2].id,
              'team',
              shelfKeSchvaleni1BinderId,
              'binder',
            );
            await postPermission(
              PERMISSIONS.READER_WITHOUT_SHARE,
              'allow',
              teamRefs[idx][4].id,
              'team',
              shelfKeSchvaleni1BinderId,
              'binder',
            );
          }

          // ke schvaleni 2. ur.
          const shelfKeSchvaleni2BinderId = await postBinder(
            shelfKeSchvaleni2Id,
            `${
              strediska.length > 1 ? `${stredisko.stredisko} - ` : ''
            }Ke schválení${optionalRoles.predschvalovatel ? ' 2. úr.' : ''}`,
            'orange',
          );
          if (optionalRoles.predschvalovatel) {
            await postPermission(
              PERMISSIONS.CONTRIBUTOR,
              'allow',
              teamRefs[idx][1].id,
              'team',
              shelfKeSchvaleni2BinderId,
              'binder',
            );
          } else {
            await postPermission(
              PERMISSIONS.CONTRIBUTOR,
              'allow',
              teamRefs[idx][0].id,
              'team',
              shelfKeSchvaleni2BinderId,
              'binder',
            );
          }
          await postPermission(
            PERMISSIONS.NORMAL_USER,
            'allow',
            teamRefs[idx][2].id,
            'team',
            shelfKeSchvaleni2BinderId,
            'binder',
          );
          await postPermission(
            PERMISSIONS.CONTRIBUTOR,
            'allow',
            teamRefs[idx][3].id,
            'team',
            shelfKeSchvaleni2BinderId,
            'binder',
          );
          await postPermission(
            PERMISSIONS.READER_WITHOUT_SHARE,
            'allow',
            teamRefs[idx][4].id,
            'team',
            shelfKeSchvaleni2BinderId,
            'binder',
          );

          // schvalene doklady
          const shelfSchvaleneDokladyBinderId = await postBinder(
            shelfSchvaleneDokladyId,
            `${
              strediska.length > 1 ? `${stredisko.stredisko} - ` : ''
            }Schválené doklady`,
            'green',
          );
          await postPermission(
            PERMISSIONS.READ_CONTRIBUTE,
            'allow',
            teamRefs[idx][2].id,
            'team',
            shelfSchvaleneDokladyBinderId,
            'binder',
          );
          await postPermission(
            PERMISSIONS.READ_MOVE,
            'allow',
            teamRefs[idx][3].id,
            'team',
            shelfSchvaleneDokladyBinderId,
            'binder',
          );
          await postPermission(
            PERMISSIONS.READER_WITHOUT_SHARE,
            'allow',
            teamRefs[idx][4].id,
            'team',
            shelfSchvaleneDokladyBinderId,
            'binder',
          );

          // archiv dokladu
          const shelfArchivDokladuBinderId = await postBinder(
            shelfArchivDokladuId,
            `${
              strediska.length > 1 ? `${stredisko.stredisko} - ` : ''
            }Archiv dokladů`,
            'dark_blue',
          );
          // if (
          //   optionalRoles.predschvalovatel
          // ) {
          //   await postPermission(
          //     PERMISSIONS.READER_WITHOUT_SHARE,
          //     'allow',
          //     teamRefs[idx][1].id,
          //     'team',
          //     shelfArchivDokladuBinderId,
          //     'binder',
          //   );
          // }
          await postPermission(
            PERMISSIONS.READER_WITHOUT_SHARE,
            'allow',
            teamRefs[idx][2].id,
            'team',
            shelfArchivDokladuBinderId,
            'binder',
          );
          await postPermission(
            PERMISSIONS.READ_CONTRIBUTE,
            'allow',
            teamRefs[idx][3].id,
            'team',
            shelfArchivDokladuBinderId,
            'binder',
          );
          await postPermission(
            PERMISSIONS.READER_WITHOUT_SHARE,
            'allow',
            teamRefs[idx][4].id,
            'team',
            shelfArchivDokladuBinderId,
            'binder',
          );

          // shortcuts

          // shelfPrijemTrayId
          await postShortcut(
            shelfPrijemTrayId,
            'tray',
            shelfSchvaleneDokladyBinderId,
            'binder',
            strediska.length > 1
              ? `Schválit: ${stredisko.stredisko}`
              : 'Schválit',
            'green',
          );
          if (shelfKeSchvaleni1BinderId) {
            await postShortcut(
              shelfPrijemTrayId,
              'tray',
              shelfKeSchvaleni1BinderId,
              'binder',
              strediska.length > 1
                ? `Předat: ${stredisko.stredisko}`
                : 'Předat ke schválení',
              'yellow',
            );
          } else {
            await postShortcut(
              shelfPrijemTrayId,
              'tray',
              shelfKeSchvaleni2BinderId,
              'binder',
              strediska.length > 1
                ? `Předat: ${stredisko.stredisko}`
                : 'Předat ke schválení',
              'orange',
            );
          }

          // shelfKeSchvaleni1BinderId
          if (shelfKeSchvaleni1BinderId) {
            await postShortcut(
              shelfKeSchvaleni1BinderId,
              'binder',
              shelfSchvaleneDokladyBinderId,
              'binder',
              'Schválit',
              'green',
            );
            await postShortcut(
              shelfKeSchvaleni1BinderId,
              'binder',
              shelfKeSchvaleni2BinderId,
              'binder',
              'Posunout ke schválení 2. úr.',
              'orange',
            );
          }

          // shelfKeSchvaleni2BinderId
          await postShortcut(
            shelfKeSchvaleni2BinderId,
            'binder',
            shelfSchvaleneDokladyBinderId,
            'binder',
            'Schválit',
            'green',
          );
          if (shelfKeSchvaleni1BinderId) {
            await postShortcut(
              shelfKeSchvaleni2BinderId,
              'binder',
              shelfKeSchvaleni1BinderId,
              'binder',
              'Vrátit',
              'yellow',
            );
          }

          // shelfSchvaleneDokladyBinderId
          await postShortcut(
            shelfSchvaleneDokladyBinderId,
            'binder',
            shelfArchivDokladuBinderId,
            'binder',
            'Archivovat',
            'dark_blue',
          );
          await postShortcut(
            shelfSchvaleneDokladyBinderId,
            'binder',
            shelfKeSchvaleni2BinderId,
            'binder',
            'Vrátit',
            'orange',
          );
        }

        await setRoomDefaultEmailTarget(shelfPrijemTrayId);
        await sendEmailsToUsers();

        return true;
      } catch (error) {
        console.error(error);
        this.setState({appError: 'default'}, this.scrollToTop);
      }
    };

    this.setState({postingResources: true}, async () => {
      console.log('>> POST RESOURCES >>');
      this.scrollToTop();
      const ok = await postResources();
      if (ok) {
        console.log('.. RESOURCES POSTED ..');

        console.log('>> POST GENERATE MAGIC TOKEN >>');
        fetch(`${this.apiURL}/users/${userEmail}:generate-magic-token`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${verificationToken}`,
          },
        }).then(response => {
          const ok = this.handleResponse(
            response,
            `POST /users/${userEmail}:generate-magic-token`,
          );
          if (ok) {
            response.json().then(data => {
              if (
                data &&
                data.data &&
                data.data.token &&
                data.data.token.encoded
              ) {
                console.log(
                  `.. MAGIC TOKEN FETCHED: ${data.data.token.encoded} ..`,
                );
                console.log('>> REMOVE ITEMS FROM SESSIONSTORAGE >>');
                sessionStorage.removeItem('dm-onboarding-current_step');
                sessionStorage.removeItem('dm-onboarding-user_email');
                sessionStorage.removeItem('dm-onboarding-room_id');
                sessionStorage.removeItem('dm-onboarding-room_display_name');
                sessionStorage.removeItem('dm-onboarding-room_system_name');
                sessionStorage.removeItem('dm-onboarding-start_process_setup');
                sessionStorage.removeItem('dm-onboarding-strediska');
                sessionStorage.removeItem('dm-onboarding-optional_roles');
                console.log('.. ITEMS REMOVED FROM SESSIONSTORAGE ..');
                window.Intercom('trackEvent', 'finished-onboarding');
                if (window.dataLayer) {
                  window.dataLayer.push({event: 'finished-onboarding'});
                }
                console.log('>> REDIRECT TO DM');
                // console.log(
                //   `${this.dmURL}/magic?token=${data.data.token.encoded}`,
                // );
                window.location.replace(
                  `${this.dmURL}/magic?token=${data.data.token.encoded}`,
                );
              } else {
                console.error('.. SOMETHING WENT WRONG ..');
                this.setState({appError: 'default'}, this.scrollToTop);
              }
            });
          }
        });
      } else {
        console.error('.. SOMETHING WENT WRONG ..');
        this.setState({appError: 'default'}, this.scrollToTop);
      }
    });
  }

  // invitation + welcome

  async handleUpdateUser(
    name,
    phoneNumber,
    password,
    routeName,
  ) {
    const {verificationToken} = this.state;
    let decodedToken;
    try {
      decodedToken = jwt_decode(verificationToken);
    } catch (error) {
      console.error('.. SOMETHING WENT WRONG ..', error);
      this.setState({appError: 'tokenRouteInvalid'}, this.scrollToTop);
      return;
    }
    const userEmail = decodedToken.sub.split(' ')[1];

    return await fetch(`${this.apiURL}/users/${userEmail}`, {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${verificationToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        data: {
          email: userEmail,
          name,
          phoneNumber,
          password,
        },
      }),
    }).then(response => {
      this.handleResponse(
        response,
        `PATCH /users/${userEmail}`,
        undefined,
        routeName,
      );
      return response.status;
    });
  }

  async handleUpdateRoom(
    name,
    billingEmail,
    address,
    city,
    postalCode,
    businessId,
    vatId,
  ) {
    const {verificationToken} = this.state;
    let decodedToken;
    try {
      decodedToken = jwt_decode(verificationToken);
    } catch (error) {
      console.error('.. SOMETHING WENT WRONG ..', error);
      this.setState({appError: 'tokenRouteInvalid'}, this.scrollToTop);
      return;
    }
    const encodedRoomUuid = decodedToken.sub.split(' ')[0];
    const encoder = new UuidEncoder('base58');
    const roomUuid = encoder.decode(encodedRoomUuid);

    const customerId = await fetch(`${this.apiURL}/rooms/${roomUuid}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${verificationToken}`,
        'Content-Type': 'application/json',
      },
    }).then(async response => {
      const ok = await this.handleResponse(
        response,
        `GET /rooms/${roomUuid}`,
        undefined,
        'welcome',
      );
      if (ok) {
        return response.json().then(async data => {
          if (
            data &&
            data.data &&
            data.data.customer &&
            data.data.customer.data &&
            data.data.customer.data.id
          ) {
            return data.data.customer.data.id;
          }
        });
      } else {
        console.error('.. SOMETHING WENT WRONG ..');
        this.setState({appError: 'default'}, this.scrollToTop);
      }
    });

    return await fetch(
      `${this.apiURL}/customers/${customerId}`,
      {
        method: 'PATCH',
        headers: {
          Authorization: `Bearer ${verificationToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            name,
            identifiers: {
              businessId,
              vatId,
            },
            registeredOffice: {
              address,
              city,
              postalCode,
              countryCode: 'CZ',
            },
            billingInformation: {
              email: billingEmail,
            },
          },
        }),
      },
    ).then(async response => {
      const ok = await this.handleResponse(
        response,
        `PATCH /customers/${customerId}`,
        undefined,
        'welcome',
      );
      if (ok) {
        return response.status;
      } else {
        console.error('.. SOMETHING WENT WRONG ..');
        this.setState({appError: 'default'}, this.scrollToTop);
      }
    });
  }

  handleResendInvitation() {
    const {resendToken, linkSent} = this.state;
    let decodedToken;
    try {
      decodedToken = jwt_decode(resendToken);
    } catch (error) {
      console.error('.. SOMETHING WENT WRONG ..', error);
      this.setState({appError: 'tokenRouteInvalid'}, this.scrollToTop);
      return;
    }
    const userEmail = decodedToken.sub.split(' ')[1];

    this.setState({linkSent: linkSent === 'once' ? 'twice' : 'once'}, () => {
      fetch(`${this.apiURL}/users/${userEmail}:resend-invitation`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${resendToken}`,
          'Content-Type': 'application/json',
        },
      }).then(response =>
        this.handleResponse(
          response,
          `POST /users/${userEmail}:resend-invitation`,
          undefined,
          'invitation',
        ),
      );
    });
  }

  handleResendWelcome() {
    const {resendToken, linkSent} = this.state;
    let decodedToken;
    try {
      decodedToken = jwt_decode(resendToken);
    } catch (error) {
      console.error('.. SOMETHING WENT WRONG ..', error);
      this.setState({appError: 'tokenRouteInvalid'}, this.scrollToTop);
      return;
    }
    const userEmail = decodedToken.sub.split(' ')[1];

    this.setState({linkSent: linkSent === 'once' ? 'twice' : 'once'}, () => {
      fetch(`${this.apiURL}/users/${userEmail}:resend-welcome`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${resendToken}`,
          'Content-Type': 'application/json',
        },
      }).then(response =>
        this.handleResponse(
          response,
          `POST /users/${userEmail}:resend-welcome`,
          undefined,
          'welcome',
        ),
      );
    });
  }

  async handleRedirectToDm() {
    const {verificationToken} = this.state;
    let decodedToken;
    try {
      decodedToken = jwt_decode(verificationToken);
    } catch (error) {
      console.error('.. SOMETHING WENT WRONG ..', error);
      this.setState({appError: 'tokenRouteInvalid'}, this.scrollToTop);
      return;
    }
    const userEmail = decodedToken.sub.split(' ')[1];

    await fetch(`${this.apiURL}/users/${userEmail}:generate-magic-token`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${verificationToken}`,
      },
    }).then(response => {
      const ok = this.handleResponse(
        response,
        `/users/${userEmail}:generate-magic-token`,
      );
      if (ok) {
        response.json().then(data => {
          if (data && data.data && data.data.token && data.data.token.encoded) {
            // console.log(`${this.dmURL}/magic?token=${data.data.token.encoded}`);
            window.location.replace(
              `${this.dmURL}/magic?token=${data.data.token.encoded}`,
            );
          } else {
            console.error('.. SOMETHING WENT WRONG ..');
            this.setState({appError: 'default'}, this.scrollToTop);
          }
        });
      }
    });
  }

  // end

  render() {
    const {
      currentStep,
      displaySteps,
      verificationToken,
      appError,
      userEmail,
      validUserEmail,
      linkSent,
      roomDisplayName,
      roomSystemName,
      validatingRoomSystemName,
      validRoomSystemName,
      startProcessSetup,
      strediska,
      strediskaGroupInputs,
      optionalRoles,
      processWithErrors,
      postingResources,
    } = this.state;

    return appError ? (
      <AppError
        handleSendLink={this.handleSendLink}
        handleResendInvitation={this.handleResendInvitation}
        handleResendWelcome={this.handleResendWelcome}
        linkSent={linkSent}
        type={appError}
      />
    ) : (
      <Router basename={process.env.PUBLIC_URL}>
        <Switch>
          <Route exact path="/">
            {displaySteps && <div className="appScrollingCover" />}

            <AppProgress currentStep={currentStep} />
            <AppStepper
              currentStep={currentStep}
              handleStep={this.handleStep}
            />

            {!verificationToken && currentStep === 1 && (
              <div id="step1" className="appMain appPadded">
                <Step1
                  handleUserEmailChange={this.handleUserEmailChange}
                  handleSendLink={this.handleSendLink}
                  linkSent={linkSent}
                  userEmail={userEmail}
                  validUserEmail={validUserEmail}
                />
              </div>
            )}

            {verificationToken && (currentStep === 2 || displaySteps === '23') && (
              <div id="step2" className="appMain appPadded">
                <Step2
                  validateToken={this.validateToken}
                  currentStep={currentStep}
                  handleRoomCreate={this.handleRoomCreate}
                  handleRoomNameChange={this.handleRoomNameChange}
                  roomDisplayName={roomDisplayName}
                  roomSystemName={roomSystemName}
                  validatingRoomSystemName={validatingRoomSystemName}
                  validRoomSystemName={validRoomSystemName}
                />
              </div>
            )}

            {verificationToken && (currentStep === 3 || displaySteps === '34') && (
              <div id="step3" className="appMain appPadded">
                <Step3
                  validateToken={this.validateToken}
                  handleProcessCheck={this.handleProcessCheck}
                  handleGroupToggle={this.handleGroupToggle}
                  handleGroupInputChange={this.handleGroupInputChange}
                  handleGroupInputAdd={this.handleGroupInputAdd}
                  handlePersonChange={this.handlePersonChange}
                  handlePersonAdd={this.handlePersonAdd}
                  handlePersonRemove={this.handlePersonRemove}
                  handlePersonKeyDown={this.handlePersonKeyDown}
                  handleStrediskoAdd={this.handleStrediskoAdd}
                  handleStrediskoRename={this.handleStrediskoRename}
                  handleStrediskoRemove={this.handleStrediskoRemove}
                  handleStartProcessSetup={this.handleStartProcessSetup}
                  handleSkipProcessSetup={this.handleSkipProcessSetup}
                  startProcessSetup={startProcessSetup}
                  postingResources={postingResources}
                  strediska={strediska}
                  strediskaGroupInputs={strediskaGroupInputs}
                  optionalRoles={optionalRoles}
                  validateEmail={this.validateEmail}
                  processWithErrors={processWithErrors}
                />
              </div>
            )}

            {verificationToken && (currentStep === 4 || displaySteps === '43') && (
              <div id="step4" className="appMain appPadded">
                <Step4
                  validateToken={this.validateToken}
                  currentStep={currentStep}
                  handlePostResources={this.handlePostResources}
                  handleStep={this.handleStep}
                  postingResources={postingResources}
                  strediska={strediska}
                  optionalRoles={optionalRoles}
                  roomSystemName={roomSystemName}
                />
              </div>
            )}
          </Route>

          <Route path="/invitation">
            <div id="invitation" className="appMain">
              <Invitation
                validateRouteToken={this.validateRouteToken}
                handleUpdateUser={this.handleUpdateUser}
                handleRedirectToDm={this.handleRedirectToDm}
              />
            </div>
          </Route>

          <Route path="/welcome">
            <div id="welcome" className="appMain">
              <Welcome
                validateRouteToken={this.validateRouteToken}
                handleUpdateUser={this.handleUpdateUser}
                paramsObject={getSearchParams()}
              />
            </div>
          </Route>

          <Route path="/finalize">
            <div id="finalize" className="appMain">
              <Finalize
                validateRouteToken={this.validateRouteToken}
                handleUpdateRoom={this.handleUpdateRoom}
                handleRedirectToDm={this.handleRedirectToDm}
                validateEmail={this.validateEmail}
              />
            </div>
          </Route>
        </Switch>
      </Router>
    );
  }
}

export default hot(App);
